import { useMutation } from '@tanstack/react-query';

import { useHttpClient } from '@bonusly/http-client';

interface TranscriptBonusReasonParams {
	transcript_text: string;
}

export const useTranscriptBonusReason = (options = {}) => {
	const http = useHttpClient('v2');

	return useMutation(
		async (params: TranscriptBonusReasonParams) => {
			const response = await http.post('/video/transcript_bonus_reason', {
				transcript_text: params.transcript_text,
			});
			return response.data;
		},
		{
			retry: false,
			...options,
		}
	);
};
